
const $ = require('jquery');

// Block pinch zooming
document.addEventListener('wheel', event => {
  if (event.ctrlKey) {
    event.preventDefault();
    return;
  }
}, { passive: false });

function handleLink (event) {
  const { target } = event;
  const { href = '' } = target;

  // Allow only hash change's
  if (!href.startsWith('#')) {
    console.error(`Prevented navigation to '${href}'`);
    event.preventDefault();
  }
}

const preventPageExit = target => {
  $(target).on('click touched', 'a', handleLink);
};

const blaclistTags = /<(iframe|script|style|embed|form).*<\/\1>/gmi;

// sanitizeHTML :: String -> String
const sanitizeHTML = html => html.replace(
  blaclistTags, ''
);

module.exports = {
  preventPageExit,
  sanitizeHTML
};
